module.exports = __webpack_public_path__ + "img/teamPage_4_6.222dc572.png";